module.exports = __webpack_public_path__ + "img/nach_der_geburt_mf.c1e137f6.svg";